import { render, staticRenderFns } from "./PinxFooter_mobile.vue?vue&type=template&id=779f06d8&scoped=true&"
import script from "./PinxFooter_mobile.vue?vue&type=script&lang=js&"
export * from "./PinxFooter_mobile.vue?vue&type=script&lang=js&"
import style0 from "./PinxFooter_mobile.vue?vue&type=style&index=0&id=779f06d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779f06d8",
  null
  
)

/* custom blocks */
import block0 from "./PinxFooter_mobile.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports